import { API_HEADERS, createDesignationsLookupHeaders } from '../constants/apiHeaders';
import api from '../utils/api';
import { SYSTEM_ENDPOINTS } from './endpoints/system.endpoints';
import { VACANCY_ENDPOINTS } from './endpoints/rec/vacancy.endpoints';
import type {
  VacancyQuestionResponse,
  VacancySearchParams,
  VacancySearchResponse,
} from './types/vacancy.types';

export const vacancyService = {
  search: (
    params: VacancySearchParams,
    extraHeaders?: Record<string, string>,
  ) => {
    const queryParams: Record<string, string> = {};
    Object.entries(params).forEach(([key, value]) => {
      if (value !== '' && value !== undefined) {
        queryParams[key] = String(value);
      }
    });
    return api.get<VacancySearchResponse>(
      `${VACANCY_ENDPOINTS.search}?${new URLSearchParams(queryParams)}`,
      {
        headers: {
          ...API_HEADERS.VACANCY_SEARCH_LIST,
          ...extraHeaders,
        },
      },
    );
  },

  delete: (vacancyId: number) =>
    api.delete(VACANCY_ENDPOINTS.byId(vacancyId), {
      headers: { ...API_HEADERS.VACANCY_SEARCH_DELETE },
    }),

  clone: (vacancyId: number) =>
    api.post(VACANCY_ENDPOINTS.clone(vacancyId), {}, {
      headers: { ...API_HEADERS.VACANCY_SEARCH_CLONE },
    }),

  publishJob: (vacancyId: number) =>
    api.post(VACANCY_ENDPOINTS.publishJob(vacancyId), {}, {
      headers: { ...API_HEADERS.VACANCY_SEARCH_PUBLISH_JOB },
    }),

  deleteJob: (vacancyId: number) =>
    api.post(VACANCY_ENDPOINTS.deleteJob(vacancyId), {}, {
      headers: { ...API_HEADERS.VACANCY_SEARCH_DELETE_JOB },
    }),

  withdrawApproval: (vacancyId: number) =>
    api.put(VACANCY_ENDPOINTS.withdraw(vacancyId), {}, {
      headers: { ...API_HEADERS.VACANCY_SEARCH_WITHDRAW },
    }),

  getList: () =>
    api.get<{
      vacancies: {
        id: number;
        vacancyName: string;
        vacancyCode: string;
        vacancyType: string;
      }[];
    }>(VACANCY_ENDPOINTS.list),

  searchDesignations: (query: string, pageId: number) =>
    api.get<{ data: { id: number; designation: string; designationCode: string }[] }>(
      SYSTEM_ENDPOINTS.designations,
      {
        headers: { ...createDesignationsLookupHeaders(pageId) },
      },
    ),

  /** GET all interview questions for a vacancy (same endpoint as VacancyQuestionsForm). */
  getVacancyQuestions: (vacancyId: number) =>
    api.get<{ data: VacancyQuestionResponse[] }>(VACANCY_ENDPOINTS.questions(vacancyId), {
      headers: { ...API_HEADERS.VACANCY_INTERVIEW_QUESTIONS_LIST },
    }),

  /** GET questions for one level (used after save reload in VacancyQuestionsForm). */
  getVacancyQuestionsByLevel: (vacancyId: number, questionLevel: 0 | 1 | 5) =>
    api.get<{ data: VacancyQuestionResponse[] }>(
      VACANCY_ENDPOINTS.questions(vacancyId, questionLevel),
      { headers: { ...API_HEADERS.VACANCY_INTERVIEW_QUESTIONS_LIST } },
    ),
};
